import "./styles.scss";
import { Button, Input } from "antd";
import { IoRefreshOutline } from "react-icons/io5";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import PageHeader from "../../components/pageHeader";
import DataTable from "./componets/dataTable";

function DigitalTwinScreen() {
  const navigate = useNavigate();
  return (
    <main>
      <Container fluid>
        <PageHeader
          title={"Digital Twins ( 275 )"}
          breadcum={"Dashboard / Digital Twins"}
        >
          <div>
            <Input placeholder="Search" />
          </div>
          <div>
            <Button>
              <IoRefreshOutline size={17} />
            </Button>
          </div>
          <div>
            <Button
              type="primary"
              onClick={() => navigate("/auth/DgTwinForm/0")}
            >
              New
            </Button>
          </div>
        </PageHeader>

        <DataTable />
      </Container>
    </main>
  );
}

export default DigitalTwinScreen;
